import Vue from 'vue';
export const busDeEventos = new Vue();


import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import App from './App.vue';
import { router } from './router';
import store from './store';
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import VeeValidate from 'vee-validate';
import Vuex from 'vuex';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import Multiselect from 'vue-multiselect';
import vSelect from 'vue-select';
import VueRouter from 'vue-router'; 
import 'vue-select/dist/vue-select.css';
import {
  faHome,
  faUser,
  faUserPlus,
  faSignInAlt,
  faSignOutAlt
} from '@fortawesome/free-solid-svg-icons';

import "vue-multiselect/dist/vue-multiselect.min.css";
import Constants from "./plugins/Constants.js";

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    // Solo ignorar NavigationDuplicated, relanzar otros errores
    if (err.name !== 'NavigationDuplicated') {
      throw err;
    }
  });
};

library.add(faHome, faUser, faUserPlus, faSignInAlt, faSignOutAlt);

Vue.config.productionTip = false;

Vue.use(VeeValidate, { fieldsBagName: 'veeFields' });

Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('v-select', vSelect);

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)
Vue.component('multiselect', Multiselect)
Vue.use(Vuex);


Vue.use(Constants);
Vue.prototype.$parseDecimal = function (valor) {
  if (typeof valor === 'string') {
    return parseFloat(valor.replace(',', '.'))
  }
  return valor
}

new Vue({
  busDeEventos,
  router,
  store,
  render: h => h(App)
}).$mount('#app');

